import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import img01 from './../assets/solutions_products/solution.png'; // Adjust the path as necessary
import img02 from './../assets/solutions_products/cybersecurity.png'; // Adjust the path as necessary
import img03 from './../assets/solutions_products/power_by_orca.png'; // Adjust the path as necessary
import 'animate.css/animate.min.css'; // Import animate.css for animations



export default function CyberSecurity() {
    return (
        <Container className='cybersecurity'>
            <h2 className="text-center title">Cybersecurity Framework</h2>
            <Row>
                <div className='responsive-title'>Protecting Your Digital Assets Across</div>
                <div className='responsive-title'>Performance Scaling, Powered by Trust</div>

            </Row>
            <Row className='mt-4'>
                <p className='mb-4 content text-center'>
                    At Exel, we deliver agentless, enterprise-grade protection through trusted platforms like Orca Security, Proofpoint, and EC-Council. From misconfiguration detection to compliance readiness, we help secure every layer of your cloud environment.
                </p>
                <p className='text-center mb-4 content'>
                    Our Cloud-Native Application Protection Platform (CNAPP) consolidates multiple solutions into one powerful ecosystem, including:
                </p>

            </Row>
            <Row className='mt-4' >
                <Col md={6} className='mb-4'>
                    <AnimationOnScroll animateOnce={true} animateIn="- animate__flipInX" duration={.5} offset={100}>
                        <div className='mb-4 box'>
                            <ul className='list-unstyled'>
                                <li>Cloud Security Posture Management (CSPM)</li>
                                <li>Cloud Workload Protection (CWPP)</li>
                                <li>Cloud Infrastructure Entitlement Management (CIEM)</li>
                                <li>Vulnerability Management</li>
                                <li>Container & Kubernetes Security</li>
                                <li>Data Security Posture Management (DSPM)</li>
                                <li>API Security</li>
                                <li>Cloud Detection & Response (CDR)</li>
                                <li>Multi-Cloud Compliance</li>
                                <li>Application Security</li>
                                <li>AI Security Posture Management (AISPM)</li>
                            </ul>
                            <div className='text-justify'>
                                <p className='mt-4' >
                                    From visibility to remediation, we simplify cloud security without agents, without complexity, and without compromise.
                                </p>
                            </div>
                        </div>
                    </AnimationOnScroll>

                </Col>
                <Col md={6} className='mb-4'>
                    <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInUp" duration={.5} offset={100}>
                        <div className='hover-zoom bg-white'>
                            <img src={img02} alt="Cybersecurity Solutions" className='img-fluid' style={{ maxWidth: '100%', height: 'auto', borderRadius: '50px' }} />
                        </div>
                    </AnimationOnScroll>
                </Col>
            </Row>
            <Row>
                <div className='mb-4 box' >
                    <Row>
                        <Col md={6}>
                            <div className='box-title' >
                                What Powers It All:
                            </div>
                        </Col>
                        <Col md={6} className="text-md-end text-start">
                            <img src={img03} alt="Power by Orca" className='img-fluid' style={{ width: '30%', height: 'auto' }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className='mt-4'>
                            <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInUp" duration={.5} offset={100}>
                                <div style={{ marginBottom: '20px' }}>
                                    <h4>Agentless Cloud Security</h4>
                                    <p>Protect workloads without lifting a finger no installs, no maintenance, no drama.</p>
                                </div>

                                <div style={{ marginBottom: '20px' }}>
                                    <h4>Personal Data Protection Law-Ready Advisory</h4>
                                    <p>Navigate data privacy laws like a pro, with clear guidance and strategic compliance mapping.</p>
                                </div>
                                <div style={{ marginBottom: '20px' }}>
                                    <h4>Human-Firewall Training</h4>
                                    <p>Empower your team to recognize threats, not click them because your people are your first defense.</p>
                                </div>
                                <div style={{ marginBottom: '20px' }}>
                                    <h4>API Threat Shield</h4>
                                    <p>Detect, control, and seal off API loopholes before attackers even find them.</p>
                                </div>
                            </AnimationOnScroll>

                        </Col>
                        <Col md={6} className='mt-4'>
                            <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInDown" duration={.5} offset={100}>
                            <div style={{ marginBottom: '20px' }}>
                                <h4>Inbox Armor (Human Centric Email Security)</h4>
                                <p>Stop phishing, spoofing, and social engineering where it hurts at the human level.</p>
                            </div>

                            <div style={{ marginBottom: '20px' }}>
                                <h4>Smart Data Guardrails</h4>
                                <p>Classify, monitor, and lock down sensitive data before it walks out the door.</p>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <h4>Security Operations Center-as-a-Service (SOCaaS)</h4>
                                <p>Your 24/7 threat hunters always on, always watching, no in-house SOC required.</p>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <h4>Automated Threat Response / Managed Detection and Response (MDR)</h4>
                                <p>Detect. Prioritize. Neutralize fast. Let AI and experts cut through the noise.</p>
                            </div>
                            </AnimationOnScroll>
                        </Col>
                    </Row>
                </div>
            </Row>


        </Container>
    )

}